import { useAddAddendumForSessionMutation } from '@uplift/queries';
import { useAlert } from '../../../../AlertProvider';
import * as Yup from 'yup';

export type AddendumFormType = {
  content: string;
  submittedBillingUpdate: boolean | null;
};

export const useAddendumForm = (sessionId: string) => {
  const snackbar = useAlert();
  const addAddendumMutation = useAddAddendumForSessionMutation();
  const initialValues: AddendumFormType = {
    content: '',
    submittedBillingUpdate: null
  };

  const validationSchema = Yup.object({
    content: Yup.string().required('Please specify additions or changes'),
    submittedBillingUpdate: Yup.boolean().nullable().required('Please select an option')
  });

  const onSubmit = async (values: AddendumFormType) => {
    try {
      addAddendumMutation.mutateAsync({
        sessionId: sessionId,
        content: values.content,
        submittedBillingUpdate: values.submittedBillingUpdate ?? false,
      });
      snackbar.success('Addendum added');
    } catch (error) {
      snackbar.error('Could not add addendum');
    }

  };

  return { initialValues, validationSchema, onSubmit };
};
